import api from "../..";
import type { PatchPostParams } from "./types";

export const patchPost = async ({ id, body }: PatchPostParams): Promise<boolean> => {

  return await api.patch(`/admin/posts/${id}/`, body)
  .then(() => true)
  .catch(() => false);
};
